<template>
  <div>
    <b-form v-if="!otpStep" @submit.prevent="submit">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Email Address" :invalid-feedback="validationInvalidFeedback(loginErrors, 'email')">
            <b-form-input class="text-monospace" autocomplete="username" :disabled="isLoggingIn" :state="validationState(loginErrors, 'email')" type="email" v-model="email"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Password" :invalid-feedback="validationInvalidFeedback(loginErrors, 'password')">
            <b-form-input class="text-monospace" autocomplete="current-password" :disabled="isLoggingIn" :state="validationState(loginErrors, 'password')" type="password" v-model="password"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" offset-md="8">
          <b-button block type="submit" variant="secondary"><b-spinner small v-if="isLoggingIn"></b-spinner><span v-if="!isLoggingIn">Log In</span></b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-form v-else @submit.prevent="submit">
      <b-row>
        <b-col cols="12">
          <h4 class="text-center">Two Factor Verification</h4>
          <p class="mb-4 text-muted text-center">Enter your two factor authentication code to login.</p>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Authentication Code" :invalid-feedback="otpInvalidFeedback" :state="otpInputState">
            <b-form-input
              ref="otpInput"
              class="text-monospace"
              autocomplete="one-time-code"
              inputmode="numeric"
              autocapitalize="off"
              autocorrect="off"
              spellcheck="false"
              :disabled="isLoggingIn"
              :state="otpInputState"
              v-model="otpCode"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-button block variant="outline-primary" type="button" @click="goBack">Back</b-button>
        </b-col>
        <b-col cols="12" md="6">
          <b-button block type="submit" variant="secondary"><b-spinner small v-if="isLoggingIn"></b-spinner><span v-if="!isLoggingIn">Verify</span></b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import validation from '../../mixins/validation'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      email: '',
      password: '',
      otpCode: '',

      otpStep: false,
    }
  },
  mixins: [validation],
  computed: {
    ...mapGetters('authentication', ['isLoggingIn', 'loginErrors']),
    otpInvalidFeedback () {
      return this.validationInvalidFeedback(this.loginErrors, 'otp_code')
        || this.validationInvalidFeedback(this.loginErrors, 'password')
        || this.validationInvalidFeedback(this.loginErrors, 'email')
    },
    otpInputState () {
      return this.otpInvalidFeedback ? false : this.validationState(this.loginErrors, 'otp_code')
    }
  },
  methods: {
    ...mapActions('authentication', ['login']),
    goBack () {
      this.otpStep = false
      this.otpCode = ''
    },
    readOtpCode () {
      const input = this.$refs.otpInput
      const raw = (input && input.$el ? input.$el.value : this.otpCode) || this.otpCode || ''

      return String(raw).replace(/\s+/g, '')
    },
    submit () {
      let data = { email: this.email, password: this.password };
      if(this.otpStep) data['otp_code'] = this.readOtpCode()

      this.login(data).then(response => {
        if(response == '2fa-required') {
          this.otpStep = true
          return
        }
        if(response && response.data) {
          this.$router.push( ( this.$route.query.next || '/' ) )
        }
      }).catch(err => {})
    }
  }
}
</script>

<style>

</style>
